var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.source)?_c('img',{staticClass:"openmoji",style:(_setup.style),attrs:{"src":_setup.source,"alt":_vm.alt}}):_c('span',[_vm._v(_vm._s(_setup.fallbackCharacter))])
}
var staticRenderFns = []

export { render, staticRenderFns }